// extracted by mini-css-extract-plugin
module.exports = {"container":"TechnicianResultsPDFStyles_container__hUYJg","text":"TechnicianResultsPDFStyles_text__1iBJb","buttons":"TechnicianResultsPDFStyles_buttons__cftYc"};